export interface ParsedMCQ {
  question: string;
  choices: string[];
}

/**
 * Parse bulk MCQ text into array of questions
 * Supports formats: 1. ... \n A. ... B. ... C. ... D. ...
 */
export function parseMultipleChoiceBulk(input: string): ParsedMCQ[] {
  const lines = input.split(/\r?\n/).map(l => l.trim()).filter(l => l);
  const result: ParsedMCQ[] = [];
  let i = 0;
  while (i < lines.length) {
    // Detect question line: hỗ trợ "Câu 1:", "1.", "1:", "Câu 2.", ...
    const qMatch = lines[i].match(/^(?:câu\s*)?(\d+)[.:：)]?\s*(.*)$/i);
    if (qMatch) {
      let question = qMatch[2].trim();
      i++;
      let choices: string[] = [];
      while (i < lines.length) {
        // Nếu là dòng bắt đầu câu hỏi mới thì break
        if (/^(?:câu\s*)?\d+[.:：)]?\s*/i.test(lines[i])) break;
        // Nếu là dòng chứa nhiều đáp án (A. ... B. ... C. ... D. ...)
        const multiAns = lines[i].match(/A[.\):：-]?\s*[^A-D]*B[.\):：-]?|B[.\):：-]?\s*[^A-D]*C[.\):：-]?|C[.\):：-]?\s*[^A-D]*D[.\):：-]?/);
        if (multiAns || /([A-D][.\):：-]?)/g.test(lines[i])) {
          // Tách tất cả đáp án trên dòng này
          const ansArr = [];
          const regex = /([A-D])[.\):：-]?\s*([^A-D]*)/g;
          let m;
          while ((m = regex.exec(lines[i])) !== null) {
            ansArr.push(m[2].trim());
          }
          if (ansArr.length > 0) choices.push(...ansArr);
          i++;
          continue;
        }
        // Nếu là dòng bắt đầu bằng A. ... hoặc B. ...
        const aMatch = lines[i].match(/^([A-D])[.\):：-]?\s*(.*)$/);
        if (aMatch) {
          choices.push(aMatch[2].trim());
          i++;
        } else if (lines[i].match(/^([A-D])[.\):：-]?/)) {
          i++;
        } else if (choices.length > 0 && choices.length < 6) {
          // Nếu dòng này không phải đáp án, nhưng đã có đáp án trước đó, nối vào đáp án cuối (nếu không phải là câu hỏi mới)
          choices[choices.length - 1] += ' ' + lines[i];
          i++;
        } else {
          break;
        }
      }
      // Nếu chưa có đáp án, thử tách theo tab hoặc nhiều space
      if (choices.length === 0 && i < lines.length) {
        const tabChoices = lines[i].split(/\t| {2,}/).map(s => s.trim()).filter(s => s);
        if (tabChoices.length >= 2 && tabChoices.length <= 6) {
          choices = tabChoices;
          i++;
        }
      }
      result.push({ question, choices });
    } else {
      i++;
    }
  }
  return result;
}
